import { render, staticRenderFns } from "./BaseHeading.vue?vue&type=template&id=8f286132&scoped=true"
import script from "./BaseHeading.vue?vue&type=script&lang=js"
export * from "./BaseHeading.vue?vue&type=script&lang=js"
import style0 from "./BaseHeading.vue?vue&type=style&index=0&id=8f286132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f286132",
  null
  
)

export default component.exports